<template>
  <v-dialog v-model="dialog" persistent max-width="600px" @keydown.esc="closeDialog">
    <v-card>
      <v-card-title>Khách hàng đã tồn tại</v-card-title>
      <v-card-text v-if="currentItem">
        <div>
          Hiện tại đang có {{ this.items.length }} khách hàng đã tồn tại trong hệ thống. Bạn có muốn cập nhập lại hoặc
          bỏ qua tạo khách hàng này không? <br />
          <span style="color: red;">LƯU Ý: Nếu cập nhập lại khách hàng, thông tin cũ sẽ bị mất.</span>
        </div>
        <div>
          {{ this.currentItemIndex + 1 }} / {{ this.items.length }} khách hàng<br />
          Tên: {{ currentItem.buyerName }}<br />
          Số điện thoại: {{ currentItem.phone }}<br />
          Ghi chú: {{ currentItem.note }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="grey" @click="skipItem">Skip</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="updateItem(currentItem)">Update</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable no-unused-vars */
import {mapActions} from 'vuex'
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      currentItemIndex: 0
    }
  },
  computed: {
    currentItem() {
      return this.items[this.currentItemIndex]
    }
  },
  methods: {
    ...mapActions('lead', ['updateLead']),

    updateItem(item) {
      const {id, inCharge, createdBy, createdByName, ...leadData} = item
      this.updateLead({id, ...leadData})
      this.moveToNextItem()
    },

    skipItem() {
      this.moveToNextItem()
    },
    moveToNextItem() {
      if (this.currentItemIndex < this.items.length - 1) {
        this.currentItemIndex++
      } else {
        this.closeDialog()
      }
    },
    closeDialog() {
      this.dialog = false
      this.$emit('finished')
    }
  },
  watch: {
    items(newItems) {
      if (newItems.length > 0) {
        this.currentItemIndex = 0
        this.dialog = true
      }
    }
  },
  mounted() {
    if (this.items && this.items.length > 0) {
      this.currentItemIndex = 0
      this.dialog = true
    }
  }
}
</script>
